export default __webpack_public_path__ + "static/media/Stacey_Feinberg_AHV_In_Moms_We_Trust.f650df83.jpg";